var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:{unread: _vm.notification.unread}},[_c('v-card-title',{staticClass:"container-title"},[_vm._v(" "+_vm._s(_vm.notification.verb)+" ")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.notification.description)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }